import type { useSingleton } from "@tippyjs/react";
import { useAtomValue } from "jotai";
import { VoteButtonTimer } from "@/appInterface/windows/VoteWindow/VoteButtonTimer";
import { canv } from "@/canv/global";
import { VoteIcon } from "@/icons";
import { headerActiveButtonAtom, voteTimerVisibilityAtom } from "@/interface/AppStore";
import { BottomBarItem } from "@/interface/BottomBar/BottomRightBar";
import { Tooltip } from "@/interface/ui/Tooltip";

type VoteProps = {
    singletoneTarget: ReturnType<typeof useSingleton>[1];
    className?: string;
};

export const Vote = ({ singletoneTarget, className }: VoteProps) => {
    const isTimerVisible = useAtomValue(voteTimerVisibilityAtom);
    const activeButtonName = useAtomValue(headerActiveButtonAtom);

    const handleClick = () => {
        if (canv.appInterface.commentsWindow.opened) {
            canv.appInterface.commentsWindow.close();
        }

        if (canv.canvasController.activeVote) {
            if (canv.isGuest()) return;
            canv.appInterface.activeVote.open();
        } else {
            canv.appInterface.voteWindow.toggle();
        }
    };

    return (
        <Tooltip singleton={singletoneTarget} content="Голосование">
            <BottomBarItem
                className={className}
                active={activeButtonName === "vote" || canv.canvasController.activeVote}
                onClick={handleClick}
            >
                <VoteIcon />
                {isTimerVisible && canv.canvasController.activeVote?.UID && (
                    <VoteButtonTimer
                        startedAt={canv.canvasController.activeVote.start}
                        duration={canv.canvasController.activeVote.duration}
                        onUnmount={canv.appInterface.voteWindow.resetTimer}
                    />
                )}
            </BottomBarItem>
        </Tooltip>
    );
};
